import { useMemo } from "react"
import { Table } from "antd"
import type { ColumnsType } from "antd/es/table"
import type { Key } from "react"
import { DomainLv2, DomainLv2TableProps } from "../types"
import { TableActionColumn } from "@/components/TableActionColumn"
import { ID } from "@/types/common"

const DomainLv2Table = ({
  domainLv2s,
  onEdit,
  onDelete,
  loading = false,
  selectedIds = [],
  onSelectionChange,
}: DomainLv2TableProps) => {
  const columns: ColumnsType<DomainLv2> = useMemo(
    () => [
      {
        title: "二级领域名称",
        dataIndex: "name",
        key: "name",
        width: 200,
        ellipsis: true,
      },
      {
        title: "备注",
        dataIndex: "note",
        key: "note",
        ellipsis: true,
        render: (note: string) => note || "-",
      },
      TableActionColumn<DomainLv2>({
        onEdit,
        onDelete,
        deleteConfirmDescription: "确定要删除这个二级领域吗？",
        width: 150,
      }) as any,
    ],
    [onEdit, onDelete]
  )

  const rowSelection = onSelectionChange
    ? {
        selectedRowKeys: selectedIds,
        onChange: (selectedRowKeys: Key[]) => {
          onSelectionChange(selectedRowKeys as ID[])
        },
        getCheckboxProps: (record: DomainLv2) => ({
          name: record.name,
        }),
      }
    : undefined

  return (
    <Table
      columns={columns}
      dataSource={domainLv2s}
      rowKey="id"
      loading={loading}
      rowSelection={rowSelection}
      pagination={{
        showSizeChanger: true,
        showQuickJumper: true,
        showTotal: (total, range) =>
          `第 ${range[0]}-${range[1]} 条，共 ${total} 条`,
        pageSizeOptions: ["10", "20", "50", "100"],
      }}
      size="middle"
    />
  )
}

export default DomainLv2Table

